var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"icon-box"},[(_setup.isWeChat)?_c(_setup.SwitchAudioRoute):_vm._e()],1),_c(_setup.RoomInfo,{staticClass:"room-info"}),_c(_setup.EndControl)],1),_c(_setup.SwitchTheme,{attrs:{"visible":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }